export interface ApiErrorResponse {
  error_code: string;
  message: string;
  details?: string;
}

/** Shape of a structured FastAPI HTTPException detail object from this API */
export interface ApiErrorDetail {
  code: string;
  message?: string;
  expected?: string;
}

export class ApiError extends Error {
  public readonly errorCode: string;
  public readonly statusCode: number;
  public readonly details?: string;
  /** i18n key from the API, e.g. "upload.existingBodyBlock" */
  public readonly i18nCode?: string;
  /** Extra interpolation params from the API, e.g. { expected: "filename.xlsx" } */
  public readonly i18nParams?: Record<string, string>;

  constructor(
    message: string,
    errorCode: string,
    statusCode: number,
    details?: string,
    i18nCode?: string,
    i18nParams?: Record<string, string>
  ) {
    super(message);
    this.name = "ApiError";
    this.errorCode = errorCode;
    this.statusCode = statusCode;
    this.details = details;
    this.i18nCode = i18nCode;
    this.i18nParams = i18nParams;
  }

  static fromResponse(response: ApiErrorResponse, statusCode: number): ApiError {
    return new ApiError(
      response.message,
      response.error_code,
      statusCode,
      response.details
    );
  }

  static fromDetailObject(detail: ApiErrorDetail, statusCode: number): ApiError {
    const { expected } = detail;
    const i18nParams = expected ? { expected } : undefined;
    return new ApiError(
      detail.message ?? detail.code,
      detail.code,
      statusCode,
      undefined,
      detail.code,
      i18nParams
    );
  }
}
